import {
	Button,
	Flex,
	Tab,
	TabList,
	TabPanel,
	TabPanels,
} from "@chakra-ui/react";
import PageTitle from "../components/PageTitle";
import PersistingTabIndex, {
	PersistingTabIndexHandler,
} from "../components/PersistingTabIndex";
import GeneralStatsPage from "./GeneralStatsPage";
import SupemboutUsersStatsPage from "./SupemboutUsersStatsPage";
import { useRef } from "react";

export type StatsHandler = {
	exportAsCsv: () => string;
};

const StatsPage = () => {
	const tabRef = useRef<PersistingTabIndexHandler>(null);
	const generalStatsRef = useRef<StatsHandler>(null);
	const adminStatsRef = useRef<StatsHandler>(null);
	const handleExport = () => {
		if (tabRef.current === null) {
			return;
		}
		let content = "";
		switch (tabRef.current.getTab()) {
			case 0: {
				if (generalStatsRef.current) {
					content = generalStatsRef.current.exportAsCsv();
				}
				break;
			}
			case 1: {
				if (adminStatsRef.current) {
					content = adminStatsRef.current.exportAsCsv();
				}
				break;
			}
		}
		const blob = new Blob([content]);
		const link = document.createElement("a");
		link.href = URL.createObjectURL(blob);
		link.download = "export.csv";
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};
	return (
		<>
			<Flex w="100%" justify="space-between">
				<PageTitle>Statistiques</PageTitle>
				<Flex>
					<Button variant="outline" onClick={handleExport}>
						Exporter
					</Button>
				</Flex>
			</Flex>

			{/* TABS */}
			<PersistingTabIndex ref={tabRef} id="contact-centers" mt={6}>
				<TabList>
					<Tab _selected={{ color: "brand.700", borderColor: "brand.700" }}>
						Délais généraux
					</Tab>
					<Tab _selected={{ color: "brand.700", borderColor: "brand.700" }}>
						Users sup
					</Tab>
				</TabList>

				<TabPanels>
					<TabPanel px={0}>
						<GeneralStatsPage ref={generalStatsRef} />
					</TabPanel>
					<TabPanel px={0}>
						<SupemboutUsersStatsPage ref={adminStatsRef} />
					</TabPanel>
				</TabPanels>
			</PersistingTabIndex>
		</>
	);
};

export default StatsPage;
